import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

// Goes back to wherever the person came from (Signatures, a project, a list...). When the page was opened
// directly, for example from an email link, there is no previous page, so it goes to `fallbackTo`.
// `plainClassName` replaces the default look, so existing back links keep their own style.
export default function BackButton({ fallbackTo = '/dashboard', label = 'Back', className = '', plainClassName }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasPreviousPage = location.key !== 'default';

  return (
    <button
      type="button"
      onClick={() => (hasPreviousPage ? navigate(-1) : navigate(fallbackTo))}
      className={plainClassName || `inline-flex items-center gap-2 text-secondary-600 hover:text-secondary-900 ${className}`}
    >
      <ArrowLeft size={16} />
      {label}
    </button>
  );
}
